import axios from 'axios'
import { toastr } from 'react-redux-toastr'
import { initialize } from 'redux-form'
import { localInputHoursFromNow, toApiUtc } from '../utils/datetime'

// STATES
const INITIAL_VALUES = { name: '', description: '' }
const INITIAL_STATE = {
    list: [],
    show: 'list',
    errors: {}
    }

// ACTIONS
export function getList(userId, startDate = null, endDate = null, promptIds = null) {
    if(!startDate || !endDate) {
        startDate = localInputHoursFromNow(-24)
        endDate = localInputHoursFromNow(0)
    }

    // crashSignal/crashResult alimentam as colunas de atividade do bot; user
    // alimenta as séries do gráfico de fluxo de créditos.
    const relations = 'user:id,name;crashSignal:id,date,source,crash_prompt_id;crashResult:id,created_at,value'

    const request = axios.get(process.env.REACT_APP_API_HOST+'/crash_bets?search='+(userId ? 'user_id:'+userId+';': '') + toApiUtc(startDate)+';'+toApiUtc(endDate)+'&searchFields=created_at:>;created_at:<&with='+relations+'&orderBy=id&sortedBy=desc&limit=500', { silent: true })
        .then((resp) => {
            const filter = Array.isArray(promptIds)
                ? promptIds.map(Number).filter((id) => Number.isFinite(id))
                : []
            if (!filter.length) return resp

            const rows = (resp.data && resp.data.data) || []
            const filtered = rows.filter((bet) => {
                const pid = bet.crash_signal && bet.crash_signal.crash_prompt_id != null
                    ? Number(bet.crash_signal.crash_prompt_id)
                    : null
                return pid != null && filter.indexOf(pid) > -1
            })
            return {
                ...resp,
                data: { ...resp.data, data: filtered },
            }
        })

    return {
      type: "CRASH_BETS_FETCHED",
      payload: request,
    };
  }

export function create(values) {
    return submit(values, 'post')
}

// export function update(values) {
//     return submit(values, 'put')
// }

// export function remove(values) {
//     return submit(values, 'delete')
// }

function submit(values, method) {
    return dispatch => {
        const id = values.id ? values.id+0 : ''
        let filteredValues = {...values}
        if(id) delete filteredValues.id
        
        axios[method](`${process.env.REACT_APP_API_HOST}/crash_bets${id ? '/'+id : ''}`, filteredValues)
        .then(resp => {
            // toastr.success('Sucesso', 'Operação Realizada com sucesso.')
            dispatch(init())
            // dispatch(getList())
        })
        .catch(e => {
            if (!e.response) {
                toastr.error('Erro', 'Desconhecido :-/')
                console.log(e)
            } else if (!e.response.data) {
                toastr.error('Erro', e.response.message)
            } else if (e.response.data.errors) {
                Object.entries(e.response.data.errors).forEach(
                    ([key, error]) => toastr.error(key, error[0]))
            } else if (e.response.data) {
                toastr.error('Erro', e.response.data.message)
            }
        })
    }
}

export function showContent(flag) {
    return {
        type: 'CRASH_BET_CONTENT_CHANGED',
        payload: flag
    }
}

// export function showUpdate(crashBet) {
//     return [
//         showContent('form'),
//         initialize('crashBetForm', crashBet)
//     ]
// }

export function init() {
    return [
        initialize('crashBetForm', INITIAL_VALUES),
        showContent('list')
    ]
}

// REDUCER
export function crashBetReducer (state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'CRASH_BETS_FETCHED':
            return {...state, list: action.payload.data ? action.payload.data.data : []}

        case 'CRASH_BET_CONTENT_CHANGED':
            return {...state, show: action.payload}

        default:
            return state;
    }
}